import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc3103a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "main",
  class: "MainLayout-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "© Opti-Soft 2022")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainMenu = _resolveComponent("MainMenu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_DxScrollView = _resolveComponent("DxScrollView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createVNode(_component_MainMenu)
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_DxScrollView, {
        width: "100%",
        height: "98%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("footer", null, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _createElementVNode("span", null, "Дата и время сервера: " + _toDisplayString(_ctx.serverTime), 1)
      ])
    ])
  ]))
}